import { FC } from 'react';

import { Attention } from '@dynamika-shared/ui/icons';
import { BackButton } from '@dynamika-shared/ui/BackButton/BackButton';

type WorkstationPageHeaderProps = {
  title: string;
  assigneeExist: boolean;
  goToTaskInfo: () => void;
  loading: boolean;
};

const skeleton = () => {
  return (
    <div className='flex items-center justify-between w-full'>
      <div className='w-[140px] h-[48px] bg-brightGray animate-pulse rounded-[1.6rem]'></div>
      <div className='w-[140px] h-[48px] bg-brightGray animate-pulse rounded-[1.6rem]'></div>
    </div>
  );
};

export const WorkstationPageHeader: FC<WorkstationPageHeaderProps> = ({
  title,
  assigneeExist,
  goToTaskInfo,
  loading,
}) => {
  if (loading) {
    return skeleton();
  }
  return (
    <div className='flex items-center'>
      {!assigneeExist && <BackButton action={goToTaskInfo} />}
      <h2 className='leading-40 text-left text-[3.6rem] font-semibold tracking-normal flex'>
        {title}
      </h2>
      {!assigneeExist && (
        <div className='flex items-center justify-center pl-[1.6rem] text-vividTangelo text-1424'>
          <Attention className='text-vividTangelo' />
          <span className='ml-1'>
            You are in the view-only mode. Only task assignee can make changes
            in the task.
          </span>
        </div>
      )}
    </div>
  );
};
